module.exports = __webpack_public_path__ + "img/foundrySpatialLogo-06ff0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/map/foundrySpatialLogo.svg
// module id = 27
// module chunks = 0